import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import { getAllBanners } from "../../services/HomePage/BannerApi";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

export default function TrendingToday() {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const PrevArrow = ({ onClick }) => (
    <div
      onClick={onClick}
      className="absolute left-0 top-1/2 -translate-y-1/2 z-10
      bg-white/80 hover:bg-red-500 text-red-500 hover:text-white
      shadow-lg p-3 rounded-full cursor-pointer"
    >
      <FaChevronLeft size={18} />
    </div>
  );

  const NextArrow = ({ onClick }) => (
    <div
      onClick={onClick}
      className="absolute right-0 top-1/2 -translate-y-1/2 z-10
      bg-white/80 hover:bg-red-500 text-red-500 hover:text-white
      shadow-lg p-3 rounded-full cursor-pointer"
    >
      <FaChevronRight size={18} />
    </div>
  );

  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 600,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2500,
    variableWidth: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
  };

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        const res = await getAllBanners(4);

        console.log("📦 API RESPONSE:", res);

        const data = Array.isArray(res)
          ? res
          : Array.isArray(res?.data)
          ? res.data
          : [];

        setBanners(data);
      } catch (error) {
        console.error("❌ Error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBanners();
  }, []);

  const getImageUrl = (item) => {
    const imageName =
      item.image ||
      item.bannerImage ||
      item.imageName ||
      item.bannerUrl;

    if (!imageName) return "";

    if (item.imageUrl) return item.imageUrl;

    return `https://online-tech.in/BannerImage/${encodeURIComponent(
      imageName.trim()
    )}`;
  };

  const handleBannerClick = (item) => {
    const categoryId = Number(item.productCategoryId);
    if (categoryId > 0) {
      navigate(`/trending-today/${categoryId}`);
    }
  };

  const validBanners = useMemo(() => banners, [banners]);

  if (loading) {
    return (
      <h5 className="text-center mt-4 text-red-500">
        Loading banners...
      </h5>
    );
  }

  if (!validBanners.length) return null;

  return (
    <div className="relative px-4 md:px-8 py-6 bg-white rounded-2xl shadow-xl mt-3">
     
       <h4 className="text-2xl md:text-3xl font-extrabold mb-6 text-red-600 tracking-wide text-center">
          Trending Today
      </h4>

      <Slider {...settings}>
        {validBanners.map((item, i) => {
          const imgUrl = getImageUrl(item);

          return (
            <div key={item.id || i} className="px-2">
              <div
                onClick={() => handleBannerClick(item)}
                className="w-[220px] h-[260px] rounded-xl overflow-hidden cursor-pointer shadow-md"
              >
                <img
                  src={imgUrl}
                  alt="banner"
                  className="w-full h-full object-cover"
                  loading="lazy"
                  onError={(e) => {
                    console.log("FAILED IMAGE:", imgUrl);
                    e.target.src = "https://via.placeholder.com/220x260";
                  }}
                />
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
}